import { render, staticRenderFns } from "./OrganizationView.vue?vue&type=template&id=a2c58cd4&scoped=true&"
import script from "./OrganizationView.vue?vue&type=script&lang=js&"
export * from "./OrganizationView.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationView.vue?vue&type=style&index=0&id=a2c58cd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c58cd4",
  null
  
)

export default component.exports